import {
  FollowerAbilitySchema,
  type FollowerAbility,
  type FollowerAbilityId,
} from '../../../schemas/follower';
import { adepto } from './adepto';
import { animista } from './animista';
import { battitore } from './battitore';
import { combattente } from './combattente';
import { guardiaDelCorpo } from './guardia-del-corpo';
import { menestrello } from './menestrello';
import { sacerdote } from './sacerdote';
import { scassinatore } from './scassinatore';
import { scout } from './scout';

/**
 * Catalogo delle 9 Abilità codificate dei gregari (manuale V1, rr. 1342-1426).
 *
 * Ogni Abilità ha esattamente 3 mosse (una per Rango 1, 2, 3). Battitore R3
 * e Combattente R2 sostituiscono il Rango inferiore (vedi `replacesRank`).
 *
 * Il `FollowerAbilitySchema.parse` viene applicato per garantire integrità a
 * fronte di errori di trascrizione.
 */
export const FOLLOWER_ABILITIES: Record<FollowerAbilityId, FollowerAbility> = {
  adepto: FollowerAbilitySchema.parse(adepto),
  animista: FollowerAbilitySchema.parse(animista),
  battitore: FollowerAbilitySchema.parse(battitore),
  combattente: FollowerAbilitySchema.parse(combattente),
  'guardia-del-corpo': FollowerAbilitySchema.parse(guardiaDelCorpo),
  menestrello: FollowerAbilitySchema.parse(menestrello),
  sacerdote: FollowerAbilitySchema.parse(sacerdote),
  scassinatore: FollowerAbilitySchema.parse(scassinatore),
  scout: FollowerAbilitySchema.parse(scout),
};

/** Lista ordinata delle 9 Abilità (utile per UI). */
export const FOLLOWER_ABILITY_LIST: readonly FollowerAbility[] = Object.values(FOLLOWER_ABILITIES);

/** Lookup di una mossa di Abilità per id-Abilità + Rango. */
export function getAbilityMoveByRank(
  abilityId: FollowerAbilityId,
  rank: 1 | 2 | 3,
): FollowerAbility['ranks'][number] {
  const ability = FOLLOWER_ABILITIES[abilityId];
  const move = ability.ranks.find((m) => m.rank === rank);
  if (!move) {
    throw new Error(`Abilità ${abilityId} non ha una mossa a Rango ${rank}`);
  }
  return move;
}

export {
  adepto,
  animista,
  battitore,
  combattente,
  guardiaDelCorpo,
  menestrello,
  sacerdote,
  scassinatore,
  scout,
};
